"use client";

import type { UserPolicy } from "../../../lib/types/enums/UserPolicy";
import { useSession } from "../../../session/hooks/useSession";

export const useUserPolicy = (policy: UserPolicy): boolean => {
  const { jwtPayload } = useSession();
  return jwtPayload?.userPolicyIds?.includes(policy) ?? false;
};
